"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _customPage = require("@/api/customPage");
var _member = require("@/api/member/member");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['pageId', 'type'],
  data: function data() {
    return {
      componentCode: '',
      componentSubcode: '',
      id: '',
      dialogVisible: false,
      options: [],
      ruleForm: {
        backgroundColor: '',
        titleTextColor: '',
        dataShowTextColor: '',
        withdrawBackgroundColor: '',
        withdrawTextColor: '',
        remark: '',
        remarkTextColor: '',
        remarkBackgroundColor: '',
        popUpText: '',
        levelUpEntry: '',
        showLevel: '',
        levelUpPic: ''
      },
      rules: {
        backgroundColor: [{
          required: false
        }],
        titleTextColor: [{
          required: false
        }],
        dataShowTextColor: [{
          required: false
        }],
        withdrawBackgroundColor: [{
          required: false
        }],
        withdrawTextColor: [{
          required: false
        }],
        remark: [{
          required: false
        }],
        remarkTextColor: [{
          required: false
        }],
        remarkBackgroundColor: [{
          required: false
        }],
        popUpText: [{
          required: false
        }],
        levelUpEntry: [{
          required: false
        }],
        showLevel: [{
          required: false
        }],
        levelUpPic: [{
          required: false
        }]
      }
    };
  },
  methods: {
    delPic: function delPic() {
      this.ruleForm.levelUpPic = '';
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm.levelUpPic = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    open: function open(data) {
      var _this = this;
      this.id = data.id;
      this.componentCode = data.componentCode;
      this.componentSubcode = data.componentSubcode;
      (0, _member.memberQueryMemberGradeApi)().then(function (res) {
        _this.options = res.data;
      });
      (0, _customPage.moduleDetail)({
        moduleId: data.id
      }).then(function (res) {
        if (res.data && res.data.dataDisplay != null) {
          _this.ruleForm = (0, _objectSpread2.default)({}, res.data.dataDisplay);
        }
      });
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.ruleForm = {};
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _customPage.saveOrUpdateBanner)({
            moduleId: _this2.id,
            dataDisplay: _this2.ruleForm
          }).then(function (res) {
            if (res.data) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this2.$emit('refresh');
              _this2.onClose();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};